import React from 'react';

import CalendarInput from 'components/generic/CalendarInput.component';
import WidgetTitle from 'components/widget/WidgetTitle.component';
import { useTranslation } from 'providers/GILT.provider';

import CN from './WidgetDayDuration.module.scss';

const WidgetDayDuration = ({ disabled, value, name, tag, onChange }) => {
  const { t } = useTranslation();
  return (
    <div data-bem="WidgetDayDuration" data-tag={tag} className={CN.component}>
      <div className={CN.titleContainer}>
        <WidgetTitle tag="WidgetDayDuration__title">{t('scheduler.timeOff.startsTitle')}</WidgetTitle>
      </div>

      <div data-bem="WidgetDayDuration__body" className={CN.row}>
        <CalendarInput disabled={disabled} width="full" value={value} name={name} tag={tag} onChange={onChange} />
      </div>
    </div>
  );
};

export default WidgetDayDuration;
